import { z } from 'zod/v4';

/** One entry of the company's order-type catalogue (`tracing_order_types`). */
export const TracingOrderTypeSchema = z.object({
  id: z.string(),
  /** The type's name — `tracing_order_types.name`. */
  orderType: z.string(),
});

export type TracingOrderType = z.infer<typeof TracingOrderTypeSchema>;

/** Newest first. */
export const TracingOrderTypeListSchema = z.array(TracingOrderTypeSchema);

/** Wire shape: the standard `reply.apiSuccess` envelope around the list. */
export const TracingOrderTypeListResponseSchema = z.object({
  metadata: z.object({ success: z.literal(true) }),
  data: TracingOrderTypeListSchema,
});

export type TracingOrderTypeListResponse = z.infer<
  typeof TracingOrderTypeListResponseSchema
>;

export const CreateOrderTypeBodySchema = z.object({
  /** The new type's name. Not deduplicated: a repeated name is a second entry. */
  orderType: z.string().min(1),
});

export type CreateOrderTypeBody = z.infer<typeof CreateOrderTypeBodySchema>;

/** Wire shape: the standard `reply.apiSuccess` envelope around the new type. */
export const CreateOrderTypeResponseSchema = z.object({
  metadata: z.object({ success: z.literal(true) }),
  data: TracingOrderTypeSchema,
});

export type CreateOrderTypeResponse = z.infer<
  typeof CreateOrderTypeResponseSchema
>;
